/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Faq_Q5Inputs */

const en_to_yaml_faq_q5 = /** @type {(inputs: To_Yaml_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How does it handle values like no and yes?`)
};

const ko_to_yaml_faq_q5 = /** @type {(inputs: To_Yaml_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`no나 yes 같은 값은 어떻게 처리하나요?`)
};

const ja_to_yaml_faq_q5 = /** @type {(inputs: To_Yaml_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`no や yes のような値はどう扱われますか`)
};

/**
* | output |
* | --- |
* | "How does it handle values like no and yes?" |
*
* @param {To_Yaml_Faq_Q5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_faq_q5 = /** @type {((inputs?: To_Yaml_Faq_Q5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Faq_Q5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_faq_q5(inputs)
	if (locale === "ko") return ko_to_yaml_faq_q5(inputs)
	return ja_to_yaml_faq_q5(inputs)
});